import React from 'react';
import SideBySide from 'components/home/sidebyside';

export default function SectionImageTextAndButtonCta({ section }) {
  return <SideBySide section={section} />;
}
